import { render, staticRenderFns } from "./IconBurgerMenu.vue?vue&type=template&id=0fc8ce30&scoped=true"
import script from "./IconBurgerMenu.vue?vue&type=script&lang=js"
export * from "./IconBurgerMenu.vue?vue&type=script&lang=js"
import style0 from "./IconBurgerMenu.vue?vue&type=style&index=0&id=0fc8ce30&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc8ce30",
  null
  
)

export default component.exports